import { Col, Container, Row } from 'react-bootstrap';
import { SimpleAncer } from '../../Components/button';
import LayoutWithoutFooter from '../../layouts/layoutWithoutFooter/LayoutWithoutFooter';
import { HeadingDesc } from '../../Components/Headings';
import bg from '../../assets/images/png/account_created_bg.png';
import './login.css';
import i18n from '../../i18n';

function AccountCreated() {
  return (
    <LayoutWithoutFooter>
      <section className="loginPage">
        <div
          className="loginBg account"
          style={{ backgroundImage: `url(${bg})` }}
        >
          <div className="accountCreated">
            <Container>
              <Row>
                <Col md={5} />
                <Col md={7}>
                  <div className="content">
                    <Row>
                      <Col md={12}>
                        <h1>{i18n.t('account_created_successfully')}</h1>
                        <HeadingDesc text={i18n.t('account_created_detail')} />
                        <div className="btns_container">
                          <SimpleAncer to="/" text={i18n.t('lets_start')} />
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </section>
    </LayoutWithoutFooter>
  );
}

export default AccountCreated;
